import BeatListPage from "pages/fsm/beat"
import BeatCreationPage from "pages/fsm/beat/[id]"
import BeatMonitoringList from "pages/fsm/monitor"
import BeatMonitoringDetails from "pages/fsm/monitor/[id]"
import RouteListPage from "pages/fsm/routes/list"
import RouteDetailPage from "pages/fsm/routes/[id]"
import React from "react"
import { VesaRouteType } from "routes"

// import svg
import { ReactComponent as BeatMaster } from "assets/icons/fsm/beat-master.svg"
import { ReactComponent as BeatTracking } from "assets/icons/fsm/beat-tracking.svg"
export const fsmRoutes: VesaRouteType[] = [
  {
    path: "routes",
    icon: "route",
    title: "Route Master",
    permission: ["ds_view_route"],
    element: <RouteListPage />,
  },
  {
    path: "routes/:id",
    permission: ["ds_view_route"],
    element: <RouteDetailPage />,
    hide: true,
  },
  {
    path: "beat",
    title: "Beat Master",
    icon: BeatMaster,
    permission: ["ds_view_beat"],
    element: <BeatListPage />,
  },
  {
    path: "beat/:id",
    permission: ["ds_view_beat"],
    element: <BeatCreationPage />,
    title: "Beat Creation",
    hide: true,
  },
  {
    path: "monitor",
    icon: BeatTracking,
    title: "Beat Tracking",
    permission: ["ds_view_monitor"],
    element: <BeatMonitoringList />,
  },
  {
    hide: true,
    path: "monitor/:id",
    permission: ["ds_view_monitor"],
    element: <BeatMonitoringDetails />,
    title: "Beat Monitoring Detail",
  },
]
